var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconProduction(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3508_2884)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.1207 22.082H5.07568V38.5981H23.1207V22.082Z",
    stroke: "#83BF1F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1207 22.0841H5.07568L12.2429 9.05469H29.2845L23.1207 22.0841Z",
    stroke: "#83BF1F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9244 38.6001H23.1207V22.0841L29.2846 9.05469H42.9244V38.6001Z",
    stroke: "#83BF1F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.18266 29.1381C9.71285 29.1381 10.1427 28.704 10.1427 28.1686C10.1427 27.6332 9.71285 27.1992 9.18266 27.1992C8.65246 27.1992 8.22266 27.6332 8.22266 28.1686C8.22266 28.704 8.65246 29.1381 9.18266 29.1381Z",
    stroke: "#83BF1F",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7826 29.1381C19.3128 29.1381 19.7426 28.704 19.7426 28.1686C19.7426 27.6332 19.3128 27.1992 18.7826 27.1992C18.2524 27.1992 17.8226 27.6332 17.8226 28.1686C17.8226 28.704 18.2524 29.1381 18.7826 29.1381Z",
    stroke: "#83BF1F",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9827 29.1381C14.5129 29.1381 14.9427 28.704 14.9427 28.1686C14.9427 27.6332 14.5129 27.1992 13.9827 27.1992C13.4525 27.1992 13.0227 27.6332 13.0227 28.1686C13.0227 28.704 13.4525 29.1381 13.9827 29.1381Z",
    stroke: "#83BF1F",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1478 12.9766H24.1964",
    stroke: "#83BF1F",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8958 15.543H22.9444",
    stroke: "#83BF1F",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1427 17.9883H21.1913",
    stroke: "#83BF1F",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 31.6992,
    width: 11.16,
    height: 2.2,
    stroke: "#83BF1F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3508_2884"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38.4,
    height: 30.0522,
    fill: "white",
    transform: "translate(4.80005 8.80078)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProduction);
export default __webpack_public_path__ + "static/media/icon-production.0544119b8f9bd69ff45fd9de9b978c41.svg";
export { ForwardRef as ReactComponent };